module.exports = __webpack_public_path__ + "static/img/20.6f63151.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/eng/20.png
// module id = ZObq
// module chunks = 0